import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["state", "city"]

  connect (){
    if (document.getElementById('candidate_state_id') != null)
      this.byState(document.getElementById('candidate_state_id'));
  }

  async byState(e) {
    this.resetPole();
    const cities = await this.fetchCities(e);
    this.cityTarget.readonly = cities.length == 0 ;
    this.cityTarget.parentNode.style.display = cities.length == 0 ? 'none' : '';
    this.cityTarget.innerHTML = cities.length > 0 ? `<option>Selecione a cidade</option>${cities.map(city => `<option value="${city.id}">${city.name}</option>`).join('')}` : '';
  }

  async fetchCities(e) {
    const select = e.currentTarget === undefined ? e : e.currentTarget;
    const selectedOption = select.options[select.selectedIndex];
    const dataUrl = selectedOption.getAttribute('data-url');
    if (dataUrl == null) {
      this.cityTarget.value = null;
      return [];
    }

    const response = await fetch(dataUrl)
    return await response.json();
  }

  resetPole() {
    if (location.href.match(/editar|nova/)) {
      document.getElementById('poles').innerHTML = '';
    }
  }
}
